import React, { useRef, useState, useEffect } from 'react';
import { Button, Input, Modal, ModalHeader, ModalBody, ModalFooter  } from 'reactstrap';
import UsersAutocomplete from './Numbers/UsersAutocomplete';
import { PROVINCE_OPTIONS, COUNTRY_LIST } from '../utils/constants';
import { toast } from 'react-toastify';
import { useUnifiedFetch } from '../hooks';
import { useUnifiedMutate } from "../hooks/useUnifiedMutate.js";

const NumberMaskForm = ({ searchNumber, states, clearSearchedNumbers, resetSelectedNumbers, orderNew, user,closeModal ,onReceiveNumbers}) => {
  console.log('states',states)
  
  const formRef = useRef(null);
  const [selectedState, setSelectedState] = useState('');
  const [country, setCountry] = useState(COUNTRY_LIST[0]);
  const [stateOrProvince, setStateOrProvince] = useState({ label: 'State', value: states || [] });
  const [provider, setProvider] = useState('');
  const provinces = PROVINCE_OPTIONS?.map(item => item.label);
  
  // Fetching state data and mutation hooks
  const { data: stateData, fetchData: fetchStateData } = useUnifiedFetch(`/states`, true, true);
  const { mutate: callCdrLogsApi, isLoading: isRetrievingCdrLogs } = useUnifiedMutate();

  const handleFetchCdrLogs = async (data) => {
    // sendNumbersToParent
    const endpoint = provider === 'Inteliquent' ? 'numbers/inteliquent/query' : 'numbers/query';
    try {
      const response = await callCdrLogsApi({
        endpoint,
        method: 'POST',
        body: data,
      });
      if (response) {
        // toast.success('CDR logs retrieved successfully.');
        // console.log('CDR Logs:', response);
        if (response.tnResult.length > 0) {
          closeModal()
          onReceiveNumbers(response.tnResult);  // Call the parent’s callback with the numbers array
        }else{
          toast.error('No Number Found');
        }
      }
    } catch (error) {
      toast.error('Failed to retrieve CDR logs.');
      console.error('Error fetching CDR logs:', error);
    }
  };

  useEffect(() => {
    if (orderNew == true) {
      const selectedProvider = process.env.REACT_APP_TEMP_NUMBER_CAREER_INTELIQUENT === 'true' ? 'Inteliquent' : 'VoiceTel';
      setProvider(selectedProvider);
      if (['superAdmin', 'companyGroupAdmin', 'supportEngineer'].includes(user?.role)) {
        fetchStateData();
      }
    }
  }, [orderNew, user, fetchStateData]);

  const handleClearButton = () => {
    formRef.current.reset();
    setSelectedState({ ...selectedState, state: '' });
    clearSearchedNumbers();
    resetSelectedNumbers([]);
  };
  const handleNewOrderClearButton = () => {
    formRef.current.reset();
    setSelectedState('');
    setCountry(COUNTRY_LIST[0])
  };

  const validateMask = (data) => {
    const maskFields = ['m1', 'm2', 'm3', 'm4', 'm5', 'm6', 'm7', 'm8', 'm9', 'm10'];
    return maskFields.every(field => !isNaN(data[field]) || data[field] === '' || data[field] === 'x');
  };

  const handleSubmit = () => {
    const form = formRef.current;
    const data = {
      qty: form.qty.value || 0,
      state: selectedState.state,
      m1: form['m-1'].value || 'x',
      m2: form['m-2'].value || 'x',
      m3: form['m-3'].value || 'x',
      m4: form['m-4'].value || 'x',
      m5: form['m-5'].value || 'x',
      m6: form['m-6'].value || 'x',
      m7: form['m-7'].value || 'x',
      m8: form['m-8'].value || 'x',
      m9: form['m-9'].value || 'x',
      m10: form['m-10'].value || 'x',
    };

    if (!selectedState.state) {
      toast.error(`Please select a ${stateOrProvince?.label}`);
      return;
    }

    if (data.qty === 0 || data.qty === '') {
      toast.error('Quantity is required');
      return;
    }

    if (!validateMask(data)) {
      toast.error('Invalid entry in Mask');
      return;
    }

    // Concatenate mask fields
    const tnMask = `${data.m1}${data.m2}${data.m3}${data.m4}${data.m5}${data.m6}${data.m7}${data.m8}${data.m9}${data.m10}`;
    const requestData = {
      quantity: data.qty,
      province: data.state,
      tnMask,
    };

    if (orderNew == true) {
      handleFetchCdrLogs(requestData);
    } else {
      searchNumber(data);
    }
  };

  const handleSelectState = e => {
    if (e.suggestion !== null) {
      setSelectedState({ ...selectedState, state: e.suggestion });
    }
  };

  const handleSelectCountry = e => {
    if (e.suggestion !== null) {
      setCountry(e.suggestion);
      setStateOrProvince({
        label: e.suggestion === COUNTRY_LIST[0] ? 'State' : 'Province',
        value: e.suggestion === COUNTRY_LIST[0] ? states : provinces,
      });
      setSelectedState({ ...selectedState, state: '' });
    }
  };

  return (
    <form className="search-sidebar" ref={formRef}>
      <p className="maskForm-label">Quantity</p>
      <Input type="number" name="qty" placeholder="Quantity..." />

      <p className="maskForm-label">Country</p>
      <>
        <UsersAutocomplete
          placeholder="Country..."
          calls={COUNTRY_LIST}
          onChange={handleSelectCountry}
          name="country"
          searchTerm={country || selectedState?.country}
        />
      </>

      <p className="maskForm-label">{stateOrProvince?.label}</p>
      {/* {states && states.length > 0 && ( */}
      <>
        <UsersAutocomplete
          placeholder={`${stateOrProvince?.label}...`}
          calls={stateOrProvince?.value || []}
          onChange={handleSelectState}
          name="state"
          usage="provision"
          searchTerm={selectedState.state}
        />
      </>
      {/* )} */}

      <p className="maskForm-label">Number Mask</p>
      <div className="maskField-container">
        <Input type="tel" name="m-1" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-2" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-3" maxLength={1} placeholder="X" className="mask-field" />
        <p className="mask-divider">-</p>
        <Input type="tel" name="m-4" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-5" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-6" maxLength={1} placeholder="X" className="mask-field" />
        <p className="mask-divider">-</p>
        <Input type="tel" name="m-7" maxLength={1} Provisionsplaceholder="X" className="mask-field" />
        <Input type="tel" name="m-8" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-9" maxLength={1} placeholder="X" className="mask-field" />
        <Input type="tel" name="m-10" maxLength={1} placeholder="X" className="mask-field" />
      </div>
      <div className="NumberSearchFormContainer">
        <div>
          <Button color="primary" style={{ width: '100%' }} onClick={handleSubmit}>
            Search
          </Button>
        </div>
            <div>
            <Button color="primary" style={{ width: '100%' }} onClick={orderNew ? handleNewOrderClearButton  : handleClearButton}>
              Clear
            </Button>
          </div>

      </div>
    </form>
  );
};

export default NumberMaskForm;
